import { createSlice } from "@reduxjs/toolkit";
import {
  getDisputeList,
  getPendingDisputeList,
  getDeliveredDisputeList,
  getOrders,
  getProcessingOrders,
  getShippedOrders,
  getWaitingOrders,
  getDateFilterOrders,
  getDateFilterDisputes,
  searchOrders,
  updateOrder,
  uploadFile,
  postDisputeModalData,
  getAllOrders,
  getOrderAnalytics,
  getAllBatchProcessedOrders,
  processMultipleOrders,
  syncOrders,
  getReturnedOrders,
  getAllMails,
  calculateCostsOfOrders,
  getTotalOrders,
} from "../../api/order";
import { getAllDisputes } from "../../api/order/disputes-admin";

const initialState = {
  isLoading: false,
  isSizingTableLoading: false,
  isSync: null,
  isSuccess: false,
  orderInfo: null,
  waitingOrderInfo: null,
  processingOrderInfo: null,
  shippedOrderInfo: null,
  disputeInfo: [],
  pendingDisputeInfo: null,
  deliveredDisputeInfo: null,
  fulfillmentOrders: [],
  selectedOrdersForDeletion: [],
  calculatedFulfillmentOrders: null,
  shippedOrdersToExport: [],
  uploadedMediaFile: null,
  uploadMediaForVariant: null,
  createdDispute: null,
  newVariants: [],
  shippingMethodValue: 0,
  orderAnalytics: [],
  batchProcessOrders: [],
  isImportingOrders: false,
  orderForMapping: null,
  disputeMedia: [],
  orderReports: [],
  orderTablePage: 1,
  selectAll: false,
  returnedOrders: [],
  mailTrackers: [],
  isCalculatingCosts: false,
  calculatedCosts: null,
  ordersForCostsCalculation: [],
  totalOrders:null
};

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    getFulfillmentOrders: (state, { payload }) => {
      state.fulfillmentOrders = payload;
      state.calculatedFulfillmentOrders = payload;
    },
    getOrdersForDeletion: (state, { payload }) => {
      state.selectedOrdersForDeletion = payload;
    },
    getOrdersForCostsCalculation: (state, { payload }) => {
      state.ordersForCostsCalculation = payload;
    },
    getOrdersToExport: (state, { payload }) => {
      state.shippedOrdersToExport = payload;
    },
    getNewVariants: (state, { payload }) => {
      state.newVariants = payload;
    },
    getShippingMethodValue: (state, { payload }) => {
      state.shippingMethodValue = payload;
    },
    emptyUploadedMediaFile: (state, action) => {
      state.uploadedMediaFile = null;
    },
    emptyDisputeMedia: (state, action) => {
      state.disputeMedia = [];
    },
    getOrderForMapping: (state, { payload }) => {
      state.orderForMapping = payload;
    },
    setDisputeMedia: (state, { payload }) => {
      state.disputeMedia = payload;
    },
    setOrderTablePage: (state, { payload }) => {
      state.orderTablePage = payload;
    },
    setSelectAll: (state, { payload }) => {
      state.selectAll = payload;
    },
    setDisputeInfo: (state, { payload }) => {
      state.disputeInfo = payload;
    },
    updateOrderByQuotationProduct: (state, { payload }) => {
      const { createdProductIds } = payload;
    
      state?.orderInfo?.orders?.forEach((order) => {
        if (order?.status === "Failed" && order?.quotation_status !== "Pending") {
          order.line_items.forEach((item) => {
            if (createdProductIds.includes(item.shopify_product_id)) {
              item.quotation_request = "sent";
            }
          });
    
          const hasNotFoundStatus = order?.line_items?.some(
            (line_item) => line_item?.quotation_request === "sent"
          );
    
          const hasCompleteStatus = order?.line_items?.some(
            (line_item) => line_item?.status === "complete"
          );
    
          const allQuotationRequestsSent = order?.line_items?.every(
            (line_item) => line_item?.quotation_request === "sent"
          );
    
          if (
            (hasNotFoundStatus && hasCompleteStatus) ||
            allQuotationRequestsSent
          ) {
            order.quotation_status = "Pending";
          }
        }
      });
    },
    
  },
  extraReducers: {
    [getOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.orderInfo = payload;
    },
    [getOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.orderInfo = payload;
    },
    [calculateCostsOfOrders.pending]: (state) => {
      state.isCalculatingCosts = true;
    },
    [calculateCostsOfOrders.fulfilled]: (state, { payload }) => {
      state.isCalculatingCosts = false;
      state.calculatedCosts = payload;
    },
    [calculateCostsOfOrders.rejected]: (state, { payload }) => {
      state.isCalculatingCosts = false;
    },
    [getOrderAnalytics.pending]: (state) => {
      state.isLoading = true;
    },
    [getOrderAnalytics.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.orderAnalytics = payload;
    },
    [getOrderAnalytics.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getAllOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.orderInfo = payload;
      state.orderReports = [];
    },
    [getAllOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getTotalOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getTotalOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.totalOrders = payload;
    },
    [getTotalOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getAllBatchProcessedOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllBatchProcessedOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.batchProcessOrders = payload;
    },
    [getAllBatchProcessedOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [processMultipleOrders.pending]: (state) => {
      state.isLoading = true;
      state.isImportingOrders = true;
    },
    [processMultipleOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.isImportingOrders = false;
    },
    [processMultipleOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.isImportingOrders = false;
    },
    [searchOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [searchOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.orderInfo = payload;
      state.orderReports = payload;
    },
    [searchOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.orderInfo = payload;
    },
    [syncOrders.pending]: (state) => {
      state.isSync = true;
    },
    [syncOrders.fulfilled]: (state, { payload }) => {
      state.isSync = null;
    },
    [syncOrders.rejected]: (state, { payload }) => {
      state.isSync = null;
    },
    [updateOrder.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [updateOrder.pending]: (state) => {
      state.isLoading = true;
    },
    [updateOrder.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [getReturnedOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getReturnedOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getReturnedOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.returnedOrders = payload;
    },

    [getDateFilterOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getDateFilterOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.orderInfo = payload;
    },
    [getDateFilterOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.orderInfo = payload;
    },
    [getWaitingOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getWaitingOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.waitingOrderInfo = payload;
    },
    [getWaitingOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.waitingOrderInfo = payload;
    },
    [getProcessingOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getProcessingOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.processingOrderInfo = payload;
    },
    [getProcessingOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.processingOrderInfo = payload;
    },
    [getShippedOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getShippedOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.shippedOrderInfo = payload;
    },
    [getShippedOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.shippedOrderInfo = payload;
    },
    [postDisputeModalData.pending]: (state) => {
      state.isLoading = true;
    },
    [postDisputeModalData.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.createdDispute = payload;
    },
    [postDisputeModalData.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getAllDisputes.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllDisputes.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.disputeInfo = payload;
    },
    [getAllDisputes.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.disputeInfo = payload;
    },
    [getDisputeList.pending]: (state) => {
      state.isLoading = true;
    },
    [getDisputeList.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.disputeInfo = payload;
    },
    [getDisputeList.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.disputeInfo = payload;
    },
    [getDateFilterDisputes.pending]: (state) => {
      state.isLoading = true;
    },
    [getDateFilterDisputes.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.disputeInfo = payload;
    },
    [getDateFilterDisputes.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.disputeInfo = payload;
    },
    [getPendingDisputeList.pending]: (state) => {
      state.isLoading = true;
    },
    [getPendingDisputeList.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.pendingDisputeInfo = payload;
    },
    [getPendingDisputeList.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.pendingDisputeInfo = payload;
    },
    [getDeliveredDisputeList.pending]: (state) => {
      state.isLoading = true;
    },
    [getDeliveredDisputeList.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.deliveredDisputeInfo = payload;
    },
    [getDeliveredDisputeList.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.deliveredDisputeInfo = payload;
    },
    [getAllMails.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllMails.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.mailTrackers = payload;
    },
    [getAllMails.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [uploadFile.pending]: (state) => {
      state.isLoading = true;
      state.isSizingTableLoading = true;
    },
    [uploadFile.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSizingTableLoading = false;
      state.isSuccess = true;
      state.uploadedMediaFile = payload;
      state.uploadMediaForVariant = payload;
    },
    [uploadFile.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.isSizingTableLoading = false;
    },
  },
});
export const {
  getFulfillmentOrders,
  getOrdersForDeletion,
  getNewVariants,
  getShippingMethodValue,
  getOrdersToExport,
  emptyUploadedMediaFile,
  emptyDisputeMedia,
  getOrderForMapping,
  setDisputeMedia,
  setOrderTablePage,
  setSelectAll,
  setDisputeInfo,
  getOrdersForCostsCalculation,
  updateOrderByQuotationProduct,
} = orderSlice.actions;
export const orderSelector = (state) => state.order;
export default orderSlice.reducer;
